import React from 'react'
import BannerBoxFive from './FullWidthBanner/BannerBoxFive'
import BannerBoxFour from './UpperBanner/BannerBoxFour'
import BannerBoxOne from './UpperBanner/BannerBoxOne'
import BannerBoxThree from './UpperBanner/BannerBoxThree'
import BannerBoxTwo from './UpperBanner/BannerBoxTwo'
import BannerSlider from './BannerSlider'
import LowerBannerOne from './LowerBanner/LowerBannerOne'
import LowerBannerTwo from './LowerBanner/LowerBannerTwo'
import LowerBannerThree from './LowerBanner/LowerBannerThree'
import LowerBannerFour from './LowerBanner/LowerBannerFour'
import LowerBannerFive from './LowerBanner/LowerBannerFive'
import LowerBannerSix from './LowerBanner/LowerBannerSix'

const BannerMain = () => {
    return (
        <>
            <section>
                <div className="container-fluid">
                    <ul className="ban-lst">
                        <li>
                            <BannerBoxOne />
                            <BannerBoxTwo />
                        </li>
                        <li>
                            <BannerSlider />
                        </li>
                        <li>
                            <BannerBoxThree />
                            <BannerBoxFour />
                        </li>
                    </ul>
                </div>
            </section>
            <BannerBoxFive />
            <section>
                <div className="container-fluid">
                    <ul className="mid-pro-lst">
                        <li>
                            <LowerBannerOne/>
                        </li>
                        <li>
                            <LowerBannerTwo/>
                            <LowerBannerThree/>
                            <LowerBannerFour/>
                        </li>
                        <li>
                            <LowerBannerFive/>
                            <LowerBannerSix/>
                        </li>
                    </ul>
                </div>
            </section>

        </>
    )
}

export default BannerMain